import React, { useEffect, useState } from "react";
import styles from './MyRefralSection.module.scss';
import { convertToModule } from "factory/utils/clientUtils";
import { TXN_STATUS } from '../../../ReferAndEarn/HKCash/helper'
import { __isCallBackExist } from "factory/modules/HK_service";

const MyRefralSection = ({ handleCallBack, promotion_name, creative_slot, ...props }) => {
    const [toggle, setToggle] = useState(true)
    const { user_pts } = props.referData;
    const [refralNames, setRefralNames] = useState([])

    useEffect(() => {
        getRefralUsers();
    }, [user_pts])

    const getRefralUsers = () => {
        let refralNames = [];
        if (user_pts && user_pts.length > 0) {
            user_pts.map(eachUserPoints => {
                if (eachUserPoints.status === TXN_STATUS.CREDIT) {
                    refralNames.push(eachUserPoints.refereeUserNameOrMobileNum)
                }
            })
            setRefralNames(refralNames);
        }
    }
    const handleToggle = () => {
        let creative_name = toggle ? 'collapse' : 'expand';
        let data = {
            promotion_name: promotion_name,
            creative_slot: creative_slot,
            creative_name: creative_name,
            tbAvailablePoints: props.referData.tbAvailablePoints || 0,
            tbTotalPoints: props.referData.tbTotalPoints || 0,
            referalPoints: props.referData.referAndEarnAmountToBeGet || 0,
        }
        __isCallBackExist(handleCallBack) && handleCallBack(data)
        setToggle(!toggle)
    }

    return (
        <div className={convertToModule(styles, 'refral-history-cntnr')}>
            <div className={convertToModule(styles, 'header-cntnr')} onClick={() => (handleToggle())} >
                <div className={convertToModule(styles, 'ttl-sec')}>
                    {
                        props.myRefralSection && props.myRefralSection.scContent && props.myRefralSection.scContent.length > 0 ?
                            <img className={convertToModule(styles, "summery_icon")} src={props.myRefralSection.scContent[0].imageUrl} alt={props.myRefralSection.scContent[0].imageUrl} />
                            : <></>
                    }

                    {
                        props.myRefralSection && props.myRefralSection.dis_nm ?
                            <div className={convertToModule(styles, 'ttl')}>
                                {props.myRefralSection.dis_nm}
                            </div>
                            : <></>
                    }
                </div>

                <div className={convertToModule(styles, 'toggle-sec')}>
                    {
                        props.referData ?
                            <div className={convertToModule(styles, 'ttl')}>
                                ₹ {props.referData.tbAvailablePoints || 0}
                            </div>
                            : <></>
                    }
                    <svg className={convertToModule(styles, !toggle ? 'toggle-icon-collapsed' : 'toggle-icon')} width="13" height="8" viewBox="0 0 13 8" fill="none">
                        <path d="M11.8882 6.97166L11.4882 7.37167C11.3641 7.49514 11.1962 7.56445 11.0212 7.56445C10.8462 7.56445 10.6783 7.49514 10.5542 7.37167L6.04321 2.86066L1.52721 7.37666C1.40315 7.50014 1.23524 7.56946 1.06021 7.56946C0.885172 7.56946 0.717263 7.50014 0.593205 7.37666L0.193205 6.97666C0.0694867 6.85273 0 6.68477 0 6.50966C0 6.33455 0.0694867 6.16659 0.193205 6.04266L5.57021 0.642662C5.69216 0.513067 5.86036 0.436877 6.03821 0.430664C6.2157 0.437137 6.38349 0.513306 6.50521 0.642662L11.8772 6.02366C12.0015 6.14922 12.0709 6.31897 12.0702 6.49566C12.0729 6.5831 12.0582 6.67022 12.027 6.75194C11.9958 6.83365 11.9486 6.90835 11.8882 6.97166Z" fill="#535664" />
                    </svg>
                </div>
            </div>
            {
                toggle ?
                    <div className={convertToModule(styles, 'refral-body')}>
                        {
                            props.myRefralSection && props.myRefralSection.scContent
                                && props.myRefralSection.scContent.length > 0
                                && props.myRefralSection.scContent[0].attributeArea
                                && props.myRefralSection.scContent[0].attributeArea.length > 0 ?
                                <div className={convertToModule(styles, 'body-ttl')}>
                                    {props.myRefralSection.scContent[0].attributeArea[0].value}
                                </div>
                                : <></>
                        }
                        {
                            <div className={`${refralNames && refralNames.length < 1 ? convertToModule(styles, 'padding-botton') : ''} ${convertToModule(styles, 'body-desc')}`}>
                                {refralNames && refralNames.length > 0 ? refralNames.length : 0} people have registered
                            </div>
                        }
                        {
                            refralNames && refralNames.length > 0 && refralNames.map((eachName, index) => {
                                return (
                                    <div className={convertToModule(styles, 'usr-name')} key={'usr_' + index}>
                                        {eachName}
                                    </div>
                                )
                            })
                        }

                        <div className={convertToModule(styles, 'my-refral-footer')}>
                            <div className={convertToModule(styles, 'refral-csh-avlbl-sec')}>
                                <div className={convertToModule(styles, 'ttl-sec')}>
                                    Referral Cash Available
                                </div>
                                {
                                    props.referData ?
                                        <div className={convertToModule(styles, 'amnt')}>
                                            {props.referData.tbAvailablePoints || 0}
                                        </div>
                                        : <></>
                                }
                            </div>

                            <div className={convertToModule(styles, 'refral-csh-avlbl-sec')}>
                                <div className={convertToModule(styles, 'ttl-sec')}>
                                    Referral Cash Used
                                </div>
                                {
                                    props.referData && props.referData.tot_debited_pts && props.referData.tot_debited_pts < 0 ?
                                        <div className={convertToModule(styles, 'amnt')}>
                                            {Math.abs(props.referData.tot_debited_pts)}
                                        </div>
                                        :
                                        props.referData ?
                                            <div className={convertToModule(styles, 'amnt')}>
                                                {props.referData.tot_debited_pts || 0}
                                            </div>
                                            : <></>
                                }
                            </div>

                            <div className={convertToModule(styles, 'refral-csh-earned-sec')}>
                                <div className={convertToModule(styles, 'ttl-sec')}>
                                    Referral Earned Cash
                                </div>
                                {
                                    props.referData ?
                                        <div className={convertToModule(styles, 'amnt')}>
                                            {props.referData.tbTotalPoints || 0}
                                        </div>
                                        : <></>
                                }
                            </div>
                        </div>

                    </div>
                    : <></>
            }
        </div>
    )

}
export default MyRefralSection